import React from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Swal from "sweetalert2";
import { deleteCustomerSocialReason } from "../../../../../services/CatalogService.js";

function CustomerSocialReasonTable({
  data,
  loading,
  currentPage,
  rowsPerPage,
  sortField,
  sortDirection,
  searchValue,
  setSearchValue,
  setCurrentPage,
  setRowsPerPage,
  setSortField,
  setSortDirection,
  fetchData,
  razonSocial,
  editBaseRuta
}) {
  const editBasePath = editBaseRuta;

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        await deleteCustomerSocialReason(id, razonSocial);
        await Swal.fire(
          "Eliminado",
          "El cliente ha sido eliminado.",
          "success"
        );
        fetchData(currentPage, searchValue, sortField, sortDirection);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Hubo un problema al eliminar el cliente.", "error");
      }
    }
  };

  const columns = [
    {
      name: "RFC",
      selector: (row) => row.rfc,
      sortable: true,
      sortField: "rfc",
    },
    {
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      sortField: "name",
    },
    {
      name: "Código Postal",
      selector: (row) => row.postalCode,
      sortable: true,
      sortField: "postalCode",
    },
    {
      name: "Régimen Fiscal",
      selector: (row) => row.fiscalRegime.description,
      sortable: false,
    },
    {
      name: "CFDI",
      selector: (row) => row.cfdi.descripcion,
      sortable: false,
    },
    {
      name: "Editar",
      button: true,
      cell: (row) => (
        <Link to={`${editBasePath}/${row.id}`}>
          <i className="fa fa-pencil" />
        </Link>
      ),
    },
    {
      name: "Eliminar",
      button: true,
      cell: (row) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleDelete(row.id);
          }}
        >
          <i className="fa fa-trash text-danger" />
        </a>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        color: "#202124",
        fontSize: "14px",
        backgroundColor: "#EEEEEE",
        border: "none",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: false,
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      fetchData(1, searchValue, sortField, sortDirection);
      setCurrentPage(1);
    }
  };

  return (
    <DataTable
      columns={columns}
      data={data.data}
      progressPending={loading}
      sortServer
      pagination
      paginationServer
      paginationPerPage={rowsPerPage}
      paginationTotalRows={data.recordsTotal}
      paginationDefaultPage={currentPage}
      subHeader
      customStyles={customStyles}
      pointerOnHover
      paginationComponentOptions={paginationComponentOptions}
      noDataComponent="Sin información por mostrar"
      progressComponent={
        <Spinner animation="border">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      }
      subHeaderComponent={
        <div className="row">
          <div className="col-12">
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Buscar..."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <div
                className="input-group-text btn btn-info"
                onClick={() => {
                  fetchData(1, searchValue, sortField, sortDirection);
                  setCurrentPage(1);
                }}
              >
                <i className="fa fa-search"></i>
              </div>
            </div>
          </div>
        </div>
      }
      onChangePage={(page) => setCurrentPage(page)}
      onChangeRowsPerPage={(newPerPage) => {
        setRowsPerPage(newPerPage);
        setCurrentPage(1);
      }}
      onSort={(column, direction) => {
        setSortDirection(direction);
        setSortField(column.sortField);
        setCurrentPage(1);
      }}
    />
  );
}

export default CustomerSocialReasonTable;
